// This returns product by id
export const ProductService_GetProductTileLazy = () =>
  import("./service.grpc").then((m) => m.ProductService_GetProductTile);
ProductService_GetProductTileLazy.method =
  "aysa_api.services.product.v1.ProductService/GetProductTile" as const;

// This returns product by id
export const ProductService_GetProductTileV2Lazy = () =>
  import("./service.grpc").then((m) => m.ProductService_GetProductTileV2);
ProductService_GetProductTileV2Lazy.method =
  "aysa_api.services.product.v1.ProductService/GetProductTileV2" as const;

// Subscribes the user to a price drop notification on a particular product
export const ProductService_SubscribeToPriceDropNotificationLazy = () =>
  import("./service.grpc").then(
    (m) => m.ProductService_SubscribeToPriceDropNotification
  );
ProductService_SubscribeToPriceDropNotificationLazy.method =
  "aysa_api.services.product.v1.ProductService/SubscribeToPriceDropNotification" as const;

// Returns if the user is signed for a price drop notification on a particular product
export const ProductService_GetPriceDropNotificationStatusLazy = () =>
  import("./service.grpc").then(
    (m) => m.ProductService_GetPriceDropNotificationStatus
  );
ProductService_GetPriceDropNotificationStatusLazy.method =
  "aysa_api.services.product.v1.ProductService/GetPriceDropNotificationStatus" as const;
